var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-info",staticStyle:{"float":"right"},on:{"click":function($event){return _vm.xlsxExport(_vm.tableId, _vm.filename)}}},[_vm._v(" 下载 "),_c('i',{staticClass:"fas fa-download"})])}
var staticRenderFns = []

export { render, staticRenderFns }